import { XMarkIcon } from '@heroicons/react/16/solid';
import { DiagramFormData, DiagramFormUser } from './types';
import { useAuthStore } from '../../auth/authStore';

interface Props {
  users: DiagramFormUser[];
  setFormData: React.Dispatch<React.SetStateAction<DiagramFormData>>;
}

const MemberList = ({ users, setFormData }: Props) => {
  const roles = [
    { id: 'viewer', title: 'Viewer' },
    { id: 'editor', title: 'Editor' },
  ];
  const auth = useAuthStore((state) => state.auth);

  const filteredUsers = users.filter((user) => user.uid !== auth?.uid);

  const handleRoleChange = (
    user: DiagramFormUser,
    role: 'viewer' | 'editor'
  ) => {
    setFormData((prev: DiagramFormData) => ({
      ...prev,
      users: prev.users.map((u: DiagramFormUser) =>
        u.uid === user.uid ? { ...u, role } : u
      ),
    }));
  };

  return (
    <ul className="mx-1 mt-4 flex flex-col gap-4 ">
      {filteredUsers.map((user) => (
        <li key={user.uid} className="flex items-center justify-between">
          <span className="text-sm">{user.displayName}</span>
          <div className="flex gap-4">
            <fieldset>
              <legend className="sr-only">User Role</legend>
              <div className="space-y-6 sm:flex sm:items-center sm:space-y-0 sm:space-x-10">
                {roles.map((role) => (
                  <div
                    key={user.uid + '_' + role.id}
                    className="flex items-center"
                  >
                    <input
                      defaultChecked={role.id === user.role}
                      id={user.id + '_' + role.id}
                      disabled={
                        user.orgRole === 'viewer' && role.id === 'editor'
                      }
                      onChange={() =>
                        handleRoleChange(user, role.id as 'viewer' | 'editor')
                      }
                      name={'notification-method-' + user.uid}
                      type="radio"
                      className="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary checked:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 forced-colors:appearance-auto forced-colors:before:hidden"
                    />
                    <label
                      htmlFor={role.id}
                      className="ml-3 block text-sm/6 font-medium text-gray-900"
                    >
                      {role.title}
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
            <button
              type="button"
              className="ml-4 text-sm text-red-500 hover:text-red-700"
              onClick={() =>
                setFormData((prev: DiagramFormData) => ({
                  ...prev,
                  users: prev.users.filter(
                    (u: DiagramFormUser) => u.uid !== user.uid
                  ),
                }))
              }
            >
              <XMarkIcon className="size-5" />
            </button>
          </div>
        </li>
      ))}
    </ul>
  );
};
export default MemberList;
